import types from './types'

export default {
  setAffectedRoleData(context, affectedRoleData) {
    context.commit(types.SET_AFFECTED_ROLE, affectedRoleData)
  },
}
